import { IShipmentUnit } from "../../interfaces/order";
import { getPackageType } from "../../utils/orders";
import StarIcon from "@mui/icons-material/Star";
import BlendIcon from "@mui/icons-material/Blender";
import { IconButton } from "@mui/material";
import React from "react";

export const PackageBadge = ({ packages }: { packages: IShipmentUnit[] }) => {
  const PACKAGE_TYPE_CONFIG = {
    optimized: {
      label: "Optimizado",
      icon: StarIcon,
      style: {
        background: "#E1F5EE",
        color: "#0F6E56",
      },
    },
    mixed: {
      label: "Parcial",
      icon: BlendIcon,
      style: {
        background: "#EEEDFE",
        color: "#534AB7",
      },
    },
  };
  const type = getPackageType(packages);
  const { label, style, icon } = PACKAGE_TYPE_CONFIG[type];

  return (
    <span
      style={{
        ...style,
        display: "inline-flex",
        alignItems: "center",
        fontSize: 11,
        padding: "2px 8px",
        borderRadius: 20,
        fontWeight: 500,
        marginLeft: 6,
        gap: 2,
      }}
    >
      <IconButton
        size="small"
        style={{
          fontSize: 12,
          color: style.color,
          padding: 0,
          minWidth: "auto",
        }}
      >
        {icon && React.createElement(icon, { style: { fontSize: 12, color: style.color } })}
      </IconButton>
      {label}
    </span>
  );
};
